// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 450px) {\n  #FD button {\n    max-width: none;\n  }\n}\n#FD .ant-breadcrumb {\n  margin: 0;\n}\n#FD .ant-card-extra,\n#FD .ant-card-head-title,\n#FD .ant-card-body {\n  padding: 10px;\n}\n#FD button {\n  margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
